import { AxiosContext } from "contexts/AxiosContext";
import { blobToDataUrl } from "core/blob_operations";
import { useContext, useEffect, useState } from "react";

export const useGetAttachmentURI = (imageUrl: string | null): string | null => {
  const [attachmentURI, setAttachmentURI] = useState<string | null>(null);
  const { axios } = useContext(AxiosContext)!;

  useEffect(() => {
    const abortController = new AbortController();
    if (imageUrl === null) {
      setAttachmentURI(null);
    } else if (imageUrl?.startsWith("data:")) {
      setAttachmentURI(imageUrl);
    } else {
      axios
        .get(imageUrl, {
          responseType: "blob",
          signal: abortController.signal
        })
        .then(response => blobToDataUrl(response.data))
        .then(dataUri =>
          // When we have the image as a URI, we want to update the previewURI in the matching existing attachment entry
          setAttachmentURI(dataUri)
        );
    }

    return () => abortController.abort("unmounted");
  }, [axios, imageUrl]);

  return attachmentURI;
};
